const host = 'https://guicloud.thinkerx.com'
// const host = 'https://guicloudtest.thinkerx.com'//测试服
export default host
